"use client";

import { useEffect } from "react";
import { callServerActionSafely } from "~/lib/client/call-server-action-safely";
import { pushGA4Event } from "~/lib/ga4-browser";
import { shouldTrackClientEventOnce } from "~/lib/client/tracking-once";
import { trackEventAction } from "~/server/actions/tracking-actions";

interface ViewItemTrackingProps {
  itemId: string;
  itemName: string;
  value: number;
  attributionBridgeId?: string;
}

export function ViewItemTracking({
  itemId,
  itemName,
  value,
  attributionBridgeId,
}: ViewItemTrackingProps) {
  useEffect(() => {
    const trackingKey = `view_item:${window.location.pathname}:${itemId}`;
    if (!shouldTrackClientEventOnce(trackingKey)) return;

    pushGA4Event("view_item", {
      currency: "EUR",
      value,
      items: [
        { item_id: itemId, item_name: itemName, price: value, quantity: 1 },
      ],
    });

    void callServerActionSafely(
      "track_view_content",
      () =>
        trackEventAction(
          {
            event: "view_content",
            data: {
              contentId: itemId,
              contentName: itemName,
              value,
              sourceUrl: `${window.location.origin}${window.location.pathname}`,
            },
          },
          attributionBridgeId ? { attributionBridgeId } : undefined,
        ),
      undefined,
      { failureReporting: "warning" },
    );
  }, [attributionBridgeId, itemId, itemName, value]);

  return null;
}
